export const badgeColorCodeNonActive = '#50d359';
export const badgeColorCodeIsActive = '#f79535';